import { Box, Paper, Stack, Typography } from '@mui/material';
import type { Booking } from '../../types';
import ReservationIdentityBlock from './ReservationIdentityBlock';
import ReservationParticipantsBlock from './ReservationParticipantsBlock';
import ReservationPaymentBlock from './ReservationPaymentBlock';
import ReservationQuickActions, { type ReservationAction } from './ReservationQuickActions';
import ReservationStatusStack from './ReservationStatusStack';

type Props = {
  booking: Booking;
  actions: ReservationAction[];
  isBusy?: boolean;
};

export default function ReservationAdminCard({ booking, actions, isBusy = false }: Props) {
  const sectionSx = {
    minWidth: 0,
    height: '100%',
    p: { xs: 1.25, sm: 1.5 },
    borderRadius: 2.5,
    border: '1px solid',
    borderColor: 'divider',
    bgcolor: 'rgba(250, 248, 243, 0.7)',
  } as const;

  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 1.5, sm: 2 },
        borderRadius: 3,
        overflow: 'hidden',
        border: '1px solid rgba(36, 52, 40, 0.1)',
      }}
    >
      <Box
        sx={{
          display: 'grid',
          gap: { xs: 1.5, md: 2 },
          gridTemplateColumns: {
            xs: 'minmax(0, 1fr)',
            lg: 'minmax(0, 1.2fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1.15fr)',
          },
          alignItems: 'stretch',
        }}
      >
        <Box sx={sectionSx}>
          <ReservationIdentityBlock booking={booking} />
        </Box>

        <Box sx={sectionSx}>
          <ReservationParticipantsBlock booking={booking} />
        </Box>

        <Box sx={sectionSx}>
          <ReservationPaymentBlock booking={booking} />
        </Box>

        <Box sx={sectionSx}>
          <Stack spacing={1.5} sx={{ minWidth: 0, height: '100%' }}>
            <ReservationStatusStack booking={booking} />
            <Box sx={{ mt: { lg: 'auto' } }}>
              <Typography variant="caption" sx={{ display: 'block', mb: 0.75, color: 'text.secondary', fontWeight: 700 }}>
                Actions disponibles
              </Typography>
              <ReservationQuickActions actions={actions} isBusy={isBusy} />
            </Box>
          </Stack>
        </Box>
      </Box>
    </Paper>
  );
}
